export const themePage = {
    barChart: '特許出願件数の推移',
    pieChart: '技術区分 (IPC) ごとの出願件数割合',
    buildNum: '発明者数の推移',
    applyNum: '特許出願件数の推移（出願先の地域別）',
    applyNumSubtext: '地域',
    countryNum: '特許出願件数の推移（出願先の国/組織別）',
    countryNumSubtext: '国',
    businessNum: '企業数の推移',
    ipcNameSubtext: '技術区分',
    ipcName: '技術区分（IPC）',
    ipcLegendOthers: 'Others (上位10個のIPC以外)',
    cluster: 'クラスタ＆バリューチェーン',
    company: '企業間分析',
    country: '国別分析',
    chart: 'テーマ概要',
    year: '年',
    numberofinventors: '発明者数',
    ipcnamePie: '技術区分 (IPC)',
    patentcount: '特許出願件数',
    patentratio: '出願件数割合',
    inventorcount: '発明者数',
    companycount: '企業数',
    chart1Title: '戦略オプション',
    xSelect1: 'スコア（技術の進展度）',
    xSelect2: 'スコア成長率',
    ySelect1: '市場期待値',
    ySelect1_log: '市場期待値 (対数変換後)',
    ySelect2: 'スタートアップ市場期待値',
    ySelect2_log: 'スタートアップ市場期待値 (対数変換後)',
    ySelect3: '市場期待値成長率',
    ySelect3_2: 'スタートアップ市場期待値成長率',
    ySelect4: 'ビジネス規模',
    ySelect4_log: 'ビジネス規模（対数変換後）',
    bSelect1: '特許出願数',
    bSelect2: '特許被引用数',
    bSelect3: '固定値',
    xLabel: 'X軸',
    yLabel: 'Y軸',
    bLabel: '表示',
    table1Column1: 'クラスタID',
    table1Column2: 'クラスタ名',
    table1Column3: '領域',
    table1Column4: 'スコア',
    table1Column5: 'スコア成長率',
    table1Column6: '市場期待値',
    table1Column7: '市場期待値成長率',
    table1Column8: 'スタートアップ市場期待値',
    table1Column9: 'スタートアップ市場期待値成長率',
    table1ColumnScoreDeviation: 'スコア (偏差値)',
    table1ColumnMarketExpectation: '市場期待値 (偏差値)',
    table1ColumnStartupMarketExpectation: 'スタートアップ市場期待値 (偏差値)',
    noTable: 'クラスタを選択してください。詳細が表示されます',
    selectHistory: '履歴から選択',
    favoriteTableColumn1: '企業名',
    selectHistory1: '選択した日時',
    selectHistory2: 'クラスタID',
    selectHistory3: 'クラスタ名',
    lineCountry: '国',
    lineCompanyName: '企業名',
    linePatentCount: '特許カウント',
    lineYear: '年',
    companyIP: 'IP情報',
    seachTheme: '日本語で入力してください',
    companyDownload: '特許一覧をダウンロード',
    companyChart: '特許出願件数の推移',
    compantChartSelect: 'テーマ名',
    compantGeneralInfo: '一般情報',
    compantGeneralInfoYear: '設立年',
    compantGeneralInfoLocation: '所在地',
    compantGeneralInfoNaceCode: '産業分類コード（NACE）',
    compantGeneralInfoNaceLabel: '産業分類ラベル',
    compantGeneralInfoOwner: '最終親会社',
    compantGeneralInfoParent: '親会社',
    compantGeneralInfoSubs: '子会社',
    compantGeneralInfoWeb: 'ウェブサイト',
    compantGeneralInfoBussiness: '事業概要',
    compantFinanceTitle: '財務情報',
    compantFinanceCo1: '売上高 [百万米ドル]',
    compantFinanceCo2: '利益 [百万米ドル]',
    compantFinanceCo3: '研究開発費 [百万米ドル]',
    compantFinanceCo4: '資本金 [百万米ドル]',
    compantFinanceCo5: '総資産 [百万米ドル]',
    compantFinanceCo6: '上場先（ティッカー）',
    compantFinanceCo7: '投資元',
    compantFinanceCo8: 'EBITDA [千米ドル]',
    compantFinanceCo9: 'EBIT [千米ドル]',
    compantFinanceCo10: '税引前利益 [千米ドル]',
    compantFinanceCo11: '税引後利益 [千米ドル]',
    compantFinanceCo12: '株主資本 [千米ドル]',
    compantFinanceCo13: '株式時価総額 [千米ドル]',
    compantFinanceCo14: '従業員数',
    compantFinanceCo15: '企業価値 [千米ドル]',
    compantFinanceCo16: '1株当たり利益（EPS） [米ドル]',
    compantFinanceCo17: '1株当たりキャッシュフロー（CFPS）',
    compantFinanceCo18: '1株当たり配当金（DPS） [米ドル]',
    compantFinanceCo19: '1株当たり純資産（BPS） [米ドル]',
    compantFinanceCo20: '純資産 [千米ドル]',
    compantFinanceCo21: 'ステージ情報',
    compantFinanceCoSc: 'ティッカー',
    clusterid: 'クラスタID',
    ipccode: '筆頭IPC',
    ipcother: 'その他のIPC',
    publicationnumber: '公開番号/特許番号',
    applicationyear: '出願年',
    factorloadquantity: '因子負荷量',
    numberofforwardcitations: '被引用数',
    title: '発明の名称',
    inventor: '発明者',
    companyname: '特許出願保有企業',
    downloadTips: 'ダウンロード対象のクラスターを選択してください。',
    downloadHelpMsg: '各クラスタを指定するか、全クラスタ分の特許出願一覧を一括ダウンロードするかを選択する。',
    table5IpcName: '企業名（トップ10）'
}
